import Vue from 'vue'
import Router from 'vue-router'
import cookies from "vue-cookies";
// import login from '@/components/login'
Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export const constantRouterMap = [{
    path: '/',
    name: 'login',
    meta: {
      keepAlive: false
    },
    component: (resolve) => require(['@/view/login'], resolve),
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/home'], resolve),
  },
  {
    path: '/siteDetail',
    name: 'siteDetail',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/siteOperation/siteDetail'], resolve),
  },
  {
    path: '/dataStatistics/index',
    name: 'dataStatistics',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/dataStatistics/index'], resolve),
  },
  {
    path: '/dataStatistics/chart',
    name: 'statisticsChart',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/dataStatistics/chart'], resolve),
  },
  {
    path: '/order/index',
    name: 'orderList',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/order/index'], resolve),
  },
  {
    path: '/income/index',
    name: 'incomeList',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/income/index'], resolve),
  },
  {
    path: '/cost/costList',
    name: 'costList',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/cost/costList'], resolve),
  },
  {
    path: '/cost/deviceList',
    name: 'deviceList',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/cost/deviceList'], resolve),
  },
  {
    path: '/system/index',
    name: 'systemUser',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/system/index'], resolve),
  },
  {
    path: '/operationInfo/index',
    name: 'operationInfo',
    meta: {
      keepAlive: true
    },
    component: (resolve) => require(['@/view/operationInfo/index'], resolve),
  },
  // {
  //   path: '/',
  //   name: 'home',
  //   component: (resolve) => require(['@/view/home'], resolve),
  // },
]

// export default new Router({
//   mode: 'history',
//   routes: constantRouterMap
// })
const routes = new Router({
  mode: 'history',
  routes: constantRouterMap
})
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
routes.beforeEach((to, from, next) => {
// //如果去往登录页则放行
  if (to.path === '/') {
    next();
  } else {
    // 从本地存储里获取token
    // let token = localStorage.getItem('Authorization');
    let token = cookies.get('Authorization');
    // console.log(token)
    // 判断token是否为空如果为空则跳转到登录页 如果有则放行
    if (token === null || token === '') {
      next({path:'/'});
    } else {
      next();
    }
  }
});
export default routes



// WEBPACK FOOTER //
// ./src/router/index.js